import Allright from './allright'
export default Allright